<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
    version="1.1"
    id="svg1"
    viewBox="0 0 215 116"
    style="width: 100%; height: 100%; pointer-events: none"
  >
    <g
      :fill-opacity="fillOpacity"
      :fill="color"
      :stroke="color"
      stroke-width="0"
      stroke-linecap="round"
      stroke-linejoin="round"
      pointer-events="all"
    >
      <path
        d="M45.5 115.5H29.5H1V99.5H29.5V0.5H45.5V42H53L53.5 41.5H71.5V42.5H72V52C78 52 81.2172 48.3376 81.5 42.5H118C118.332 48.5581 122.5 52 127.5 52V42.5H141C142.156 48.155 145 52 150.5 52V42.5H176.5C176.518 47.8623 180.5 52 186 52V41.5H202L203 42H210.5V49H214V91.5H210V99H203V99.5H186.5V98H185.5V88.5C180 89 177.5 92 176.5 98H150.5V88.5C144.5 89 142 91.5 141.5 98H127.5V88.5C121.5 89 119 91.5 118 98H81.5C80.5 92 77.5 89 72.5 88.5V98H72V99.5H53V98.5H45.5V115.5Z"
        @mouseenter="handleMouseEnter"
        @mouseleave="$emit('mouseleave')"
        @mousemove="handleMouseMove"
        @click="$emit('click')"
        id="interactive-path"
      />
    </g>
  </svg>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  color?: string;
  isHovered?: boolean;
}>();

const emits = defineEmits(['mouseenter', 'mouseleave', 'mousemove', 'click']);

const fillOpacity = computed(() => {
  return props.isHovered ? 0.5 : 0.3;
});

const handleMouseEnter = (event: MouseEvent) => {
  emits('mouseenter', event);
};

const handleMouseMove = (event: MouseEvent) => {
  emits('mousemove', event);
};
</script>

<style scoped>
#interactive-path {
  transition: fill-opacity 0.2s;
}
#interactive-path:hover {
  fill-opacity: 0.5;
}
</style>
